"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupLayoutRenderer = exports.GroupLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const LayoutRenderer_1 = require("./LayoutRenderer");
const react_1 = __importDefault(require("react"));
const assert_never_1 = require("../common/assert-never");
function GroupLayout({ visible, enabled, uischema, ...props }) {
    const groupLayout = uischema;
    if ("groupType" in groupLayout) {
        const type = groupLayout.groupType;
        switch (type) {
            case "Card":
                return ((0, jsx_runtime_1.jsxs)(antd_1.Card, { ...groupLayout.cardProps, children: [groupLayout?.label && (0, jsx_runtime_1.jsx)("b", { children: groupLayout.label }), (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...props, visible: visible, enabled: enabled, elements: groupLayout.elements })] }));
            case "Divider":
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_1.Divider, { ...groupLayout.topDividerProps }), groupLayout?.label && (0, jsx_runtime_1.jsx)("b", { children: groupLayout.label }), (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...props, visible: visible, enabled: enabled, elements: groupLayout.elements }), (0, jsx_runtime_1.jsx)(antd_1.Divider, { ...groupLayout.bottomDividerProps })] }));
            default:
                try {
                    (0, assert_never_1.assertNever)(type);
                }
                catch (e) {
                    console.error(`Invalid value configured in GroupLayout UI Schema for groupType: '${type}'`);
                }
        }
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_1.Divider, {}), groupLayout?.label && (0, jsx_runtime_1.jsx)("b", { children: groupLayout.label }), (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...props, visible: visible, enabled: enabled, elements: groupLayout.elements }), (0, jsx_runtime_1.jsx)(antd_1.Divider, {})] }));
}
exports.GroupLayout = GroupLayout;
exports.GroupLayoutRenderer = react_1.default.memo(GroupLayout);
